import { render, staticRenderFns } from "./MessageSideBar.vue?vue&type=template&id=ca781f54"
import script from "./MessageSideBar.vue?vue&type=script&lang=js"
export * from "./MessageSideBar.vue?vue&type=script&lang=js"
import style0 from "./MessageSideBar.vue?vue&type=style&index=0&id=ca781f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports